export const getFillingTime = (fillingTimes) => {
    if (!fillingTimes) {
        return 0;
    }

    const totalFillingTime = Object.values(fillingTimes).reduce((sum, item) => sum + item, 0);

    return Math.round(totalFillingTime / 1000);
};
